import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { useConfirmation } from 'ui/components/Dialog/ConfirmationDialogV2'

import { handlerServerError } from '@orbit/errors'

export const useRecalculateSAR = (id: number) => {
  const queryClient = useQueryClient()
  const confirmation = useConfirmation()

  const { mutate, isPending } = useMutation<void, Error, { id: number }>({
    mutationFn: (opts) => Request.put(Request.urls.bank.sarRecalculate, opts),
    onError: (error) => handlerServerError(error),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sar-details'] })
    }
  })

  const handleRecalculateSAR = async () => {
    await confirmation.showDeleteConfirmation({
      message:
        'Are you sure you want to recalculate the SAR? This action may update all current data and cannot be undone.',
      submitButtonText: 'Recalculate',
      confirmCallback: async () => mutate({ id })
    })
  }

  return {
    handleRecalculateSAR,
    isPending
  }
}
